import * as go from 'gojs';
import * as uuid from 'uuid';
import { getPointString } from '../../../../../utils/stringify-utils';
import { EmojiNodeCreateProps } from '../models/emoji-node-create-props';
import { EmojiNode } from '../models/emoji-node.model';

export const createEmojiNode = (diagram: go.Diagram, { categoryName, location, emoji }: EmojiNodeCreateProps) => {
  const key = uuid.v4();

  diagram.commit(() =>
    diagram.model.addNodeData(new EmojiNode(key, categoryName, getPointString(location.x, location.y), emoji)),
  );

  return diagram.findNodeForKey(key);
};
